import React from 'react';
import 'react-h5-audio-player/lib/styles.css';
import ReactAudioPlayer from 'react-h5-audio-player';
import ghostImage from '../assets/images/albumimages/ghost.jpg';
import rwcImage from '../assets/images/albumimages/rwc.jpg';
import babyImage from '../assets/images/albumimages/baby.jpg';
import thriveImage from '../assets/images/albumimages/thrive.jpg';
import itchytastyImage from '../assets/images/albumimages/itchytasty.jpg';
import oceanImage from '../assets/images/albumimages/ocean.jpg';
import busyImage from '../assets/images/albumimages/busy.jpg';
import eighteenImage from '../assets/images/albumimages/18.jpg';
import bleeding from '../assets/music/bleedingoutoftime.mp3';
import cool from '../assets/music/coolinheaven.mp3';
import hear from '../assets/music/enoughtohearit.mp3';
import falling from '../assets/music/fallingoffthepier.mp3';
import itchy from '../assets/music/itchytasty.mp3';
import holiday from '../assets/music/pornoholiday.mp3';
import riggan from '../assets/music/riggan.mp3';
import settle from '../assets/music/settledown.mp3';


const imageMap = {
    "ghost.png": ghostImage,
    "rwc.png": rwcImage,
    "baby.png": babyImage,
    "thrive.png": thriveImage,
    "itchytasty.png": itchytastyImage,
    "ocean.jpg": oceanImage,
    "busy.jpg": busyImage,
    "18.jpg": eighteenImage
};

const musicMap = {
    "bleedingoutoftime.mp3": bleeding,
    "coolinheaven.mp3": cool,
    "enoughtohearit.mp3": hear,
    "fallingoffthepier.mp3": falling,
    "itchytasty.mp3": itchy,
    "pornoholiday.mp3": holiday,
    "riggan.mp3": riggan,
    "settledown.mp3": settle
}

const MusicCard = ({ album }) => {
    const imageUrl = imageMap[album.images[0].path];

    return (
        <div className="flex flex-col items-center rounded-lg shadow custom-hover-bg dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700 p-4">
            <a href={album.website} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center">
                <img className="object-cover h-full md:h-64 lg:h-80" src={imageUrl} alt={album.images[0].caption} />
                <div className="mt-4 text-center">
                    <h1 className="text-2xl font-bold tracking-tight">{album.title}</h1>
                </div>
            </a>
            <p>{album.release}</p>
            {album.audio.map((track, index) => (
                <div key={index} className="mt-4 w-full">
                    <p className="flex flex-col items-center">Sample Track: <h1>{track.title}</h1></p>
                    <ReactAudioPlayer
                        src={musicMap[track.path]}
                        controls
                        className="w-full"
                    />
                </div>
            ))}
        </div>
    );
};

export default MusicCard;